import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`The import of states does not follow any predefined rules and should be only used if no transitions are defined.
The quantity in the ItemStates must match the sum of all LineItems states' quantities.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"importLineItemState"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`lineItemId`}</inlineCode>{` - String`}</li>
        <li parentName="ul"><inlineCode parentName="li">{`state`}</inlineCode>{` - Array of `}<a parentName="li" {...{
            "href": "/api/../api/projects/orders#itemstate"
          }}>{`ItemState`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      